import React, { useState, useEffect } from "react";
import "./Gallery.css";

/* ================= SAMPLE DATA ================= */
const galleryImages = [
  {
    id: 1,
    src: "images/gallery1.jpg",
    category: "Events",
    
  },
 {
    id: 3,
    src: "images/gallery2.jpg",
    category: "Volunteers",
  
  },

  {
    id: 3,
    src: "images/gallery3.jpg",
    category: "Volunteers",
  
  },
  {
    id: 4,
    src: "images/gallery4.jpg",
    category: "Beneficiaries",
   
  },
  {
    id: 5,
    src: "images/gallery5.jpg",
    category: "Events",
   
  },
  {
    id: 6,
    src: "images/gallery6.jpg",
    category: "Programs",
   
  },
  {
    id: 7,
    src: "images/gallery7.jpg",
    category: "Volunteers",
   
  },
  {
    id: 8,
    src: "images/gallery8.jpg",
    category: "Beneficiaries",
   
  },
  {
    id: 9,
    src: "images/gallery9.jpg",
    category: "Events",
    
  },
  {
    id: 10,
    src: "images/gallery10.jpg",
    category: "Programs",
   
  },
  {
    id: 11,
    src: "images/gallery11.jpg",
    category: "Volunteers",
   
  },
  {
    id: 12,
    src: "images/gallery12.jpg",
    category: "Beneficiaries",
  
  },

{
  id: 13,
  src: "images/gallery13.jpg",
  category: "Beneficiaries",
},
{
  id: 14,
  src: "images/gallery14.jpg",
  category: "Beneficiaries",
},
{
  id: 15,
  src: "images/gallery15.jpg",
  category: "Beneficiaries",
},
{
  id: 16,
  src: "images/gallery16.jpg",
  category: "Beneficiaries",
},
{
  id: 17,
  src: "images/gallery17.jpg",
  category: "Beneficiaries",
},
{
  id: 18,
  src: "images/gallery18.jpg",
  category: "Beneficiaries",
},
];



/* ================= COMPONENT ================= */
function Gallery() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);
  const [animateItems, setAnimateItems] = useState(false);

  const filteredImages =
    activeFilter === "All"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeFilter);

  // Trigger animation when filter changes
  useEffect(() => {
    setAnimateItems(false);
    const timer = setTimeout(() => setAnimateItems(true), 50);
    return () => clearTimeout(timer);
  }, [activeFilter]);

  // Lock scroll when lightbox is open
  useEffect(() => {
    document.body.style.overflow = selectedImage ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  // Close lightbox on Escape
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <main className="gallery-page">
      {/* ================= HERO SECTION ================= */}
       <section className="beneficiaries-hero"  style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title"  className="hero-title"
  style={{
    textAlign: "center"
  }}>Our Gallery</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Gallery</span>
          </div>
        </div>
      </section>

      {/* ================= FILTER BAR ================= */}
     

      {/* ================= GRID ================= */}
      <section className="gallery-grid-section"  style={{ paddingTop: "70px" }}>
        <div className="gallery-container">
          <div className={`gallery-grid ${animateItems ? "animate-in" : ""}`}>
            {filteredImages.map((img) => (
              <div
                key={img.id}
                className="gallery-card"
                onClick={() => setSelectedImage(img)}
              >
                <div className="gallery-image-wrapper">
                  <img
                    src={img.src}
                    alt={img.title}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="gallery-overlay">
                    <span className="gallery-zoom-icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        <line x1="11" y1="8" x2="11" y2="14" />
                        <line x1="8" y1="11" x2="14" y2="11" />
                      </svg>
                    </span>
                    <h3 className="gallery-card-title">{img.title}</h3>
                    <span className="gallery-card-category">{img.category}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="gallery-empty">
              <p>No images found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* ================= LIGHTBOX ================= */}
      {selectedImage && (
        <div className="gallery-lightbox" onClick={() => setSelectedImage(null)}>
          <button
            className="lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close lightbox"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="lightbox-image"
            />
            <div className="lightbox-caption">
              <h3>{selectedImage.title}</h3>
              <span>{selectedImage.category}</span>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Gallery;